import script from "./MaintencePage.vue?vue&type=script&setup=true&lang=js"
export * from "./MaintencePage.vue?vue&type=script&setup=true&lang=js"

import "./MaintencePage.vue?vue&type=style&index=0&id=052854fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-052854fa"]])

export default __exports__